const UttarPradeshData =[
    {
        City: "Ghaziabad",
        nameOfResource: "Oxygen",
        Address: "Ghaziabad- gurudwara,indirapuram",
        Contact: "9811709255",
        Price: " ",
        Comments: "only EMERGENCY",
        verficationDataTime: "03-05-2021",
        vendorName: "ghaziabad",
    },
    
    {
        City: "Ghaziabad",
        nameOfResource: "oxygenRefill",
        Address: "Loha Mandi, Gaziabad",
        Contact: "9899605120",
        Price: " ",
        Comments: " ",
        verficationDataTime: "5th May, 11:09 am",
        vendorName: "oxygen refill",
    },
    {
        City: "Ghaziabad",
        nameOfResource: "Oxygen",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: " ",
        verficationDataTime: "03-05-2021",
        vendorName: "",
    },
    {
        City: "Lucknow",
        nameOfResource: "Oxygen",
        Address: "UP(Lucknow)",
        Contact: "9899509939",
        Price: " ",
        Comments: " ",
        verficationDataTime: "03-05-2021",
        vendorName: "AYUSH oxygen",
    },
    {
        City: "Lucknow",
        nameOfResource: "oxygenCylinder",
        Address: "UP(Lucknow)",
        Contact: "9793213100",
        Price: " ",
        Comments: "COD Available ",
        verficationDataTime: "5th may 12:15pm",
        vendorName: "oxygen cylinders",
    },
    {
        City: "Meerut",
        nameOfResource: "Oxymeter",
        Address: "",
        Contact: "7078004481",
        Price: "880 ",
        Comments: " ",
        verficationDataTime: "4th May",
        vendorName: "Pulse Oxymeter",
    },
    {
        City: "Meerut",
        nameOfResource: "Oxygen",
        Address: "",
        Contact: "9927010286",
        Price: "",
        Comments: " ",
        verficationDataTime: "5th May, 7:30pm",
        vendorName: "Kansal Industrial Gaases",
    },
    {
        
        City: "",
        nameOfResource: "Ambulance",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Beds",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "bloodBanks",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "foodDistribution",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "homeCare",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Medicines",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "resourceAgencies",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "womenInCardiology",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "humanSupporters",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
   
    {
    
        City: "",
        nameOfResource: "plasmaDonors",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "testingCenters",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
];


export default UttarPradeshData